export const ALBUMSCARD = [
    {
        id: 0,
        image: 'https://ibighit.com/bts/images/bts/discography/proof/discography-cover.png'
    },
    {
        id: 1,
        image: 'https://ibighit.com/bts/images/bts/discography/butter-2/butter-2-cover.jpg',
    },
    {
        id: 2,
        image: 'https://ibighit.com/bts/images/bts/discography/butter/butter-cover.jpg'
    },
    {
        id: 3,
        image: 'https://ibighit.com/bts/images/bts/discography/be/rwXJxHlQ87gEiJJynB1pmScl.jpg'
    },
    {
        id: 4,
        image: 'https://ibighit.com/bts/images/bts/discography/dynamite/Q7gBkUusiDcIYljQOMX9ow6W.jpg'
    },
    {
        id: 5,
        image: 'https://ibighit.com/bts/images/bts/discography/map_of_the_soul-7/img01.jpg'
    },
    {
        id: 6,
        image: 'https://ibighit.com/bts/images/bts/discography/map_of_the_soul-persona/album-cover.jpg'
    },
    {
        id: 7,
        image: 'https://ibighit.com/bts/images/bts/discography/love_yourself-answer/album-cover.jpg'
    }
    ,{
        id: 8,
        image: 'https://ibighit.com/bts/images/bts/discography/love_yourself-tear/album-cover.jpg'
    },
    {
        id: 9,
        image: 'https://ibighit.com/bts/images/bts/discography/love_yourself-her/album-cover.jpg'
    },
    {
        id: 10,
        image: 'https://ibighit.com/bts/images/bts/discography/you_never_walk_alone/album-cover.jpg'
    },
    {
        id: 11,
        image: 'https://ibighit.com/bts/images/bts/discography/wings/album-cover.jpg'
    },
    {
        id: 12,
        image: 'https://ibighit.com/bts/images/bts/discography/young_forever/album-cover.jpg'
    },
    {
        id: 13,
        image: 'https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt2/album-cover.jpg'
    },
    {
        id: 14,
        image: 'https://ibighit.com/bts/images/bts/discography/hwayangyeonhwa-pt1/album-cover.jpg'
    },
    {
        id: 15,
        image: 'https://ibighit.com/bts/images/bts/discography/dark_and_wild/album-cover.jpg'
    },
    {
        id: 16,
        image: 'https://ibighit.com/bts/images/bts/discography/skool_luv_affair/album-cover.jpg'
    },
    {
        id: 17,
        image: 'https://ibighit.com/bts/images/bts/discography/o_rul8_2/album-cover.jpg'
    },
    {
        id: 18,
        image: 'https://ibighit.com/bts/images/bts/discography/2_cool_4_school/album-cover.jpg'
    },
]